module.exports = "<h1>{{\"dashboard.history\" | translate}}</h1>\n<div class=\"history-chart\"></div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/components/historyChart/historyChart.html
 ** module id = 329
 ** module chunks = 0
 **/